<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
      >
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <div v-if="$can('can_see_dollar_and_profit')">
            <span class="ml-1">قیمت دلار :</span>
            <span class="error--text fa-font">{{ $store.state.info.dollar ? numberFormat($store.state.info.dollar) : $store.state.info.dollar }}</span>
          </div>
          <div
            v-if="!$vuetify.breakpoint.mdAndDown && $can('can_see_dollar_and_profit')"
          >
            <span class="mr-1 ml-1"> ضریب سود :</span>
            <span class="error--text fa-font">{{ $store.state.info.percent }}</span>
            <span class="error--text fa-font">%</span>
          </div>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <return-notification-button></return-notification-button>
          <app-bar-note></app-bar-note>
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span>تمامی حقوق متعلق است به <a
          href="https://anargift.com"
          class="text-decoration-none"
        >{{ $t('AppName') }}</a><span class="d-none d-md-inline"></span></span>
        <div class="align-center d-none d-md-flex">
          <span></span>
          <v-icon
            color="error"
            class="ms-2"
          >
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div>
      </div>
    </template>
    <template #v-app-content>
      <app-customizer class="d-none d-md-block"></app-customizer>
    </template>
    <notification></notification>
  </layout-content-vertical-nav>
</template>

<script>
// App Bar Components

import { mdiMenu, mdiHeartOutline, mdiCurrencyUsd } from '@mdi/js'
import AppBarNote from '@core/layouts/components/app-bar/AppBarNote.vue'
import AppBarThemeSwitcher from '@/@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import AppCustomizer from '@/@core/layouts/components/app-customizer/AppCustomizer.vue'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'
import navMenuItems from '@/navigation/vertical'
import Notification from '@/layouts/variants/components/Notification.vue'
import ReturnNotificationButton from '@/layouts/variants/components/ReturnNotificationButton.vue'

export default {
  components: {
    LayoutContentVerticalNav,
    AppCustomizer,
    AppBarThemeSwitcher,
    // App Bar Components
    AppBarUserMenu,
    AppBarNote,
    Notification,
    ReturnNotificationButton,
  },
  setup() {
    const numberFormat = number => number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')

    return {
      navMenuItems,
      numberFormat,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiCurrencyUsd,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
